// components/FAQSection.jsx
import React, { useState } from "react";
import { faqs } from "../data/faqs";
import "./FAQSection.css";

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqs.map((faq, idx) => (
          <div
            className={`faq-item ${activeIndex === idx ? "active" : ""}`}
            key={idx}
          >
            <button className="faq-question" onClick={() => toggle(idx)}>
              {faq.question}
              <span className="faq-toggle">{activeIndex === idx ? "−" : "+"}</span>
            </button>
            {activeIndex === idx && <div className="faq-answer">{faq.answer}</div>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
